import { render, staticRenderFns } from "./ImageVip.vue?vue&type=template&id=04c8bf57&scoped=true"
import script from "./ImageVip.vue?vue&type=script&lang=js"
export * from "./ImageVip.vue?vue&type=script&lang=js"
import style0 from "./ImageVip.vue?vue&type=style&index=0&id=04c8bf57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8bf57",
  null
  
)

export default component.exports